<template>
    <main>
        <Tarot />
        <Numerology />
        <Cookies />
        <About />
        <Contact />
    </main>
</template>

<script>
    import Tarot from './home/TarotHome';
    import Numerology from './home/Numerology';
    import Cookies from './home/Cookies';
    import About from './home/About';
    import Contact from './home/Contact';

    export default {
        components:
        {
            Tarot, Numerology, Cookies, About, Contact
        },
        data(){
            return {
                data: null,
                loading: true,
            }
        },

        mounted() {
            this.$root.showDescrpition = false;
            this.$root.isCardDesc = false;

            this.$nextTick(() => {
                let _this = this;
                if(this.$route.hash)
                {
                    setTimeout(function(){
                        const el = document.querySelector(_this.$route.hash);
                        el && el.scrollIntoView({behavior: "smooth"});
                    }, 1000)
                }
            });

            let _this = this;

            axios
            .get('/home/get', {
                params:
                {
                    'option': 'home_page',
                }
            }).then(response => {

                this.data = response.data;
            });
        }
    }
</script>
